import {Component, OnInit} from "@angular/core";
import {GestionGefService} from "../../../core/services/gef/gestion-gef.service";
import {UtilsService} from "../../../core/utils/utils.service";
import {ToastService} from "../../../core/services/technique/toast.service";
import {combineLatest} from "rxjs";
import {FP_ROUTES} from "../../../core/constants";
import {RoutemapService} from "../../../core/services/routemap.service";

@Component({
    selector: 'yo-monitoring-gef',
    templateUrl: './monitoring-gef.component.html',
    styleUrls: ['./monitoring-gef.component.scss'],
    standalone: false
})


export class MonitoringGefComponent implements OnInit {

  data: any[] = [];

  constructor(private utils: UtilsService,
              private toastSvc: ToastService,
              private gefSvc: GestionGefService,
              private routeMapSvc: RoutemapService) {
  }

  ngOnInit(): void {
    this.initData()
  }

  initData() {
    const fournisseurList$ = this.gefSvc.findFournisseurToValidate();
    const produitList$ = this.gefSvc.findProduitToValidate();
    const produitDeclinaisonList$ = this.gefSvc.findProduitDeclinaisonToValidate();
    const catalogueAchatList$ = this.gefSvc.findCatalogueAchatToValidate();
    const marcheList$ = this.gefSvc.findMarcheToValidate();
    const lotMarcheList$ = this.gefSvc.findLotMarcheToValidate();

    const all$ = combineLatest([fournisseurList$, produitList$, produitDeclinaisonList$, catalogueAchatList$, marcheList$, lotMarcheList$]);

    const result$ = all$.subscribe(response => {
      let fournisseurList = response[0].allFournisseurToValidateGef;
      let produitList = response[1].allProduitToValidateGef;
      let produitDeclinaisonList = response[2].allProduitDeclinaisonToValidateGef;
      let produitArticleList = response[3].allCatalogueAchatToValidateGef;
      let marcheList = response[4].allMarcheToValidateGef;
      let lotMarcheList = response[5].allLotMarcheToValidateGef;

      fournisseurList = fournisseurList.map(item => ({...item, type: 'Fournisseur'}));
      produitList = produitList.map(item => ({...item, type: 'Produit'}));
      produitDeclinaisonList = produitDeclinaisonList.map(item => ({...item, type: 'ProduitDeclinaison'}));
      produitArticleList = produitArticleList.map(item => ({...item, type: 'Article'}));
      marcheList = marcheList.map(item => ({...item, type: 'Marche'}));
      lotMarcheList = lotMarcheList.map(item => ({...item, type: 'LotMarche'}));

      this.data.push(...fournisseurList, ...produitList, ...produitDeclinaisonList, ...produitArticleList, ...marcheList, ...lotMarcheList);

    });
  }

  redirectToPage(row: any, type: string) {
    switch (type) {
      case 'Produit':
        this.routeMapSvc.goToSecondaryRoute([FP_ROUTES.GPR, 'produit', 'false', row.id, 'ficheidentite']);
        break;
      case 'ProduitDeclinaison':
        this.routeMapSvc.goToSecondaryRoute([FP_ROUTES.GPR, 'produit', 'false', row.produitId, 'produit-declinaisons']);
        break;
      case 'Article':
        this.routeMapSvc.goToSecondaryRoute([FP_ROUTES.GPR, 'produit', 'false', row.produitDeclinaison.produitId, 'articles']);
        break;
      case 'Fournisseur':
        this.routeMapSvc.goToGestionFournisseurs();
        break;
      case 'Marche':
        this.routeMapSvc.goToSecondaryRoute([FP_ROUTES.GESTION_MARCHE, 'marche', row.id, 'fiche-identite']);
        break;
      case 'LotMarche':
        this.routeMapSvc.goToSecondaryRoute([FP_ROUTES.GESTION_MARCHE, 'marche', row.id, 'lots-marche', row.id, 'infos']);
        break;
    }
  }
}
